
import { Calendar } from 'lucide-react';

interface DayCirclesProps {
  completedDays: number;
  totalDays?: number;
  showClickIndicator?: boolean;
}

const DayCircles = ({ completedDays, totalDays = 5, showClickIndicator = false }: DayCirclesProps) => {
  return (
    <div className="space-y-4">
      {/* Header with calendar icon */}
      <div className="flex items-center gap-2 justify-center">
        <Calendar className="w-5 h-5 text-vibrant-orange" />
        <span className="text-deep-blue font-medium">{totalDays} days</span>
      </div>
      
      {/* Circles in a single row for 5 days */}
      <div className="flex gap-4 justify-center items-center">
        {Array.from({ length: totalDays }, (_, index) => {
          const dayNumber = index + 1;
          const isCompleted = dayNumber <= completedDays;
          
          return (
            <div key={index} className="relative">
              <div
                className={`w-12 h-12 rounded-full border-3 flex items-center justify-center text-sm font-bold transition-all duration-500 shadow-lg ${
                  isCompleted
                    ? 'bg-green-500 border-green-400 text-white scale-110 shadow-green-200'
                    : 'bg-gray-100 border-gray-300 text-gray-500 hover:bg-gray-200'
                }`}
              >
                {isCompleted ? '✓' : dayNumber}
              </div>
              
              {/* Celebration emoji for just completed day */}
              {isCompleted && dayNumber === completedDays && (
                <div className="absolute -top-3 -right-3 text-xl animate-bounce-in">
                  🎉
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DayCircles;
